export const STATUS_CODE_UNAUTHORIZED = 401;
export const CONTENT_TYPE_JSON = 'application/json';
export const HEADER_CONTENT_TYPE = 'content-type';
export const HEADER_HTS_SESSION = 'hc-session-id';
export const HEADER_HTS_EXPERIMENTS = 'hts-experiments';
